// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { ResourceNote, ResourceNoteRequest } from "./types/resourceNotesApiTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEnterpriseCoachingResourceNotesApi = createApi({
    reducerPath: "cclTokenedEnterpriseCoachingResourceNotesApi",
    tagTypes: ["notes"],

    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllNotes: builder.query<ResourceNote[], string>({
            query: (pKey) => `enterprise-coaching/v1/ResourceNotes/${pKey}`,
            providesTags: ["notes"],
        }),
        getNote: builder.query<ResourceNote, ResourceNoteRequest>({
            query: (args) => `enterprise-coaching/v1/ResourceNotes/${args.pKey}/${args.noteType}`,
            providesTags: ["notes"],
        }),
        updateNote: builder.mutation<boolean, ResourceNote>({
            query: (args) => ({
                url: `enterprise-coaching/v1/ResourceNotes/update-note/${args.pKey}`,
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["notes"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllNotesQuery, useUpdateNoteMutation } =
    cclTokenedEnterpriseCoachingResourceNotesApi;
